{
  "page": {
    "title": "Club",
    "subtitle": "Facilities and staff",
    "balance": "Balance",
    "division": "Division {division}"
  },
  "summary": {
    "upkeep": "Upkeep per season",
    "wages": "Wages",
    "balance": "Balance"
  },
  "sections": {
    "facilities": "Facilities",
    "staff": "Staff"
  },
  "facilities": {
    "tier": "Tier {tier} / {max}",
    "notBuilt": "Not built",
    "maxed": "Fully upgraded",
    "comingSoon": "Coming soon",
    "upgrade": "Upgrade",
    "build": "Build",
    "upkeepAt": "Upkeep at level {tier}: {amount}/season",
    "upkeepNow": "Upkeep {amount}/season"
  },
  "roi": {
    "trainingBuild": "Build it to start training your riders faster",
    "scoutingBuild": "Build it to unlock hiring a chief scout",
    "academyBuild": "Build it for more weekly candidates and a profile for your intake"
  },
  "badge": {
    "active": "Active"
  },
  "hero": {
    "trainingSub": "faster training every day",
    "scouting": "Chief scout",
    "scoutingSub": "You can hire up to a tier {tier} chief",
    "academy": "{value} candidates",
    "academySub": "a week, and your profile shapes the intake"
  },
  "ladder": {
    "label": "Levels",
    "now": "now",
    "scouting": "Chief T{tier}",
    "academy": "{value} cand.",
    "unlock": {
      "origin": "region",
      "type": "+ type",
      "extra": "+1 extra",
      "stronger": "more pull"
    }
  },
  "effect": {
    "live": "Active now",
    "target": "Coming soon"
  },
  "tracks": {
    "training": {
      "name": "Training Center",
      "effect": "training",
      "soon": "Faster rider development",
      "teaser": "Your riders train faster every day."
    },
    "scouting": {
      "name": "Scouting Network",
      "effect": "rider insight",
      "soon": "Sharper rider insight",
      "teaser": "Hire a chief scout for sharper rider evaluations."
    },
    "medical": {
      "name": "Medical Department",
      "effect": "on each rider's recovery ability, plus fewer and shorter injuries",
      "soon": "Faster recovery",
      "teaser": "Your riders get their form back faster after hard races."
    },
    "academy": {
      "name": "Academy Expansion",
      "effect": "candidates a week",
      "soon": "A bigger weekly intake with your own profile",
      "teaser": "A bigger weekly intake that leans towards the riders you want."
    },
    "commercial": {
      "name": "Commercial Department",
      "effect": "sponsor (capped)",
      "soon": "Long-term sponsor income",
      "teaser": "Long-term extra sponsor income."
    }
  },
  "roles": {
    "training": "Sports Director",
    "scouting": "Chief Scout",
    "medical": "Team Doctor",
    "academy": "Academy Director",
    "commercial": "Commercial Director"
  },
  "staff": {
    "none": "No staff hired",
    "locked": "Locked: build tier 1 first",
    "hired": "Hired",
    "salary": "Salary {amount} CZ$/season",
    "candidates": "Candidates",
    "addAnother": "+ Hire another",
    "slotsFull": "Both positions are filled. Release one to hire someone new.",
    "candidate": "Tier {tier} · {amount}/season",
    "hire": "Hire",
    "release": "Release",
    "severance": "Severance {amount}",
    "tierGate": "Higher tiers unlock as you upgrade the facility",
    "billNote": "Salary is billed at season start"
  },
  "errors": {
    "insufficient_funds": "Not enough balance for that upgrade.",
    "insufficient_available_balance": "Not enough available money: part of your balance is locked in auction bids.",
    "max_tier": "This track is already fully upgraded.",
    "role_occupied": "You already have staff in this role.",
    "staff_tier_exceeds_facility": "Upgrade the facility before hiring a higher-tier chief.",
    "invalid_candidate": "That candidate is no longer available.",
    "candidate_already_hired": "That candidate is already hired in the other slot.",
    "failed": "Something went wrong. Try again.",
    "network": "Couldn't reach the server. Try again."
  },
  "empty": {
    "title": "The club is closed",
    "description": "Facilities and staff aren't available yet."
  },
  "confirm": {
    "upgradeTitle": "Confirm upgrade",
    "buildTitle": "Confirm build",
    "fireTitle": "Release {name}?",
    "cost": "Cost",
    "newTier": "New tier",
    "deductNote": "Deducted from your balance now",
    "severanceNote": "Severance is deducted now",
    "confirm": "Confirm",
    "cancel": "Cancel"
  },
  "error": {
    "load": {
      "title": "Couldn't load the club",
      "description": "Nothing was lost. Your facilities and staff are safe. Try again.",
      "retry": "Try again"
    },
    "upgrade": {
      "failed": "The purchase could not be completed. Nothing was deducted.",
      "network": "No connection to the server. Nothing was deducted.",
      "auth": "Your session expired. Sign in again and retry."
    }
  },
  "tabs": {
    "club": "Facilities",
    "staff": "Staff"
  }
}
